import React from "react";
import { CroppedScreenshot } from "../components/croppedImage.tsx";
import { api_domain } from "../config"

export function AdTable(props) {
  let ads = props.results.items
  let cur_page = props.results.page
  let page_size = props.results.size
  let total = props.results.total
  return (
    <div>
      <p className="batchTwo">
        Showing {(cur_page - 1) * page_size + 1}-{(cur_page - 1) * page_size + ads.length} of {total} {total === 1 ? "ad" : "ads"}
        &nbsp;
        {cur_page === 1 ? <button disabled className="buttonBatch" >&#8249;</button> : <button className="buttonBatch" onClick={props.prev_page}>&#8249;</button>}
        &nbsp;
        {cur_page === Math.ceil(total / page_size) ? <button disabled className="buttonBatch" >&#8250;</button> : <button className="buttonBatch" onClick={props.next_page}>&#8250;</button> }
      </p>
      <div id="dataTableDiv">
      <table className="batchDataTable" >
        <tbody>
          <tr>
            <th>Ad Id</th>
            <th>Batch Id</th>
            <th>Ad Date</th>
            <th>Parent Domain</th>
            <th>Landing Domain</th>
            <th>Ad Image</th>
          </tr>
          {ads.map((ad) => (
            <tr key={ad.id}>
              <td>
                <a href={`/ad/${ad.id}/?blur=${props.blur}`}>{ad.id}</a>
              </td>
              <td>
                <a href={`/batch/${ad.batch_id}`}>
                  {ad.batch_id}
                </a>
              </td>
              <td>
                {new Date(ad.capture_timestamp).toLocaleDateString("en-US")}
              </td>
              <td>
               {ad.parent_url === "Not Found" ? <a href={ad.parent_url}>{"Not Found"}</a> : <a href={ad.parent_url}>{new URL(ad.parent_url).hostname}</a>}
              </td>
              <td>
               {ad.landing_url === "Not Found" ? <a href={ad.landing_url}>{"Not Found"}</a> : <a href={ad.landing_url}>{new URL(ad.landing_url).hostname}</a>}
              </td>
              <td>
                <CroppedScreenshot ad={ad} blur={props.blur} url={`${api_domain}/i/${ad.path_to_image}`}/>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </div>
  );
}
